import type { ReportHandler } from 'web-vitals';

type GtagParams = Record<string, string | number | boolean | undefined>;

declare global {
  interface Window {
    /** Defined by the gtag.js snippet in index.html. Absent if the tag is blocked. */
    gtag?: (command: 'event', name: string, params?: GtagParams) => void;
  }
}

/** No-ops when gtag is blocked, offline, or absent (tests, prerender). */
export const trackEvent = (name: string, params: GtagParams = {}): void => {
  window.gtag?.('event', name, params);
};

/**
 * Pass to reportWebVitals(). CLS arrives as a fraction, so it is scaled by 1000 —
 * GA4 truncates event values to integers and would otherwise record every score as 0.
 */
export const reportWebVitalsToAnalytics: ReportHandler = ({ name, delta, id }) => {
  trackEvent(name, {
    event_category: 'Web Vitals',
    event_label: id,
    value: Math.round(name === 'CLS' ? delta * 1000 : delta),
    non_interaction: true
  });
};
